export const enum MaestrosEnum {
  ciudades = 'ciudad',
  municipios = 'municipio',
  programas = 'programas',
  pisos = 'pisos',
  instituciones = 'instituciones',
  tiposPlanes = '5',
  peso = 'pesos',
  generos = 'generos',
  tiposDeVia = 'tiposdevia',
  letradecruce = 'letradecruce',
  puntosCardinales = 'puntoscardinales',
  tipoSoporteNutricional = 'tipoSoporteNutricional'
}
